// extracted by mini-css-extract-plugin
export var infoSection = "_r-1";
export var infoSectionContainer = "_r-0";
export var infoSectionTitleRow = "_r-2";
export var multiLineInfo = "_r-4";
export var strong = "_r-3";